import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { loggedUserActions } from "./logged_user.actions";
import { exhaustMap, map, of } from 'rxjs';
import { User } from "../../models/user.model";
import { environment } from "../../../environments/environment";

@Injectable()
export class LoggedUserEffects {
    private httpClient = inject(HttpClient);
    private actions$ = inject(Actions);

    get$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loggedUserActions.getLoggedUser),
            exhaustMap(({userId}) => {
                const req = this.httpClient.get<User>(`${environment.api}/user/setting_info/${userId}`);

                return req.pipe(
                    map((payload) => {
                        // console.log(payload)
                        localStorage.setItem('name', payload.name);
                        localStorage.setItem('surname', payload.surname);
                        localStorage.setItem('role', payload.role);
                        localStorage.setItem('user_id', payload.user_id)
                        return loggedUserActions.setLoggedUser({data: payload})
                    })
                )
            })
        )
    )

    reset$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loggedUserActions.resetLoggedUser),
            exhaustMap(() => {
                const req = of(null);

                return req.pipe(
                    map(() => {
                        localStorage.removeItem('name');
                        localStorage.removeItem('surname');
                        localStorage.removeItem('role');
                    })
                )
            })
        ),
        { dispatch: false }
    )
}
